import _incodeTime from "../../lib/incodeTime.js";
import _tcLib from "../../lib/timecode.js";
const tcLib = _tcLib;
const incodeTime = _incodeTime;
export default (function calcTc(eventGroup, frameRate, dropFrame, incode) {
  eventGroup.events.forEach((event, index) => {
    try {
      if (event.endMsClock) {
        return;
      }
      event.incode = incode; //Smpte Incode
      event.incodeSec = incodeTime.incodeLabelToMediaSeconds(incode, frameRate, dropFrame);
      event.startMs = tcLib.secToTcMs(event.start, frameRate, dropFrame);
      event.endMs = tcLib.secToTcMs(event.end, frameRate, dropFrame);
      event.startMsClock = tcLib.secToTcMs(incodeTime.applyPulldownDivider(event.start, frameRate, dropFrame), frameRate, dropFrame);
      event.endMsClock = tcLib.secToTcMs(incodeTime.applyPulldownDivider(event.end, frameRate, dropFrame), frameRate, dropFrame);
      event.startMsIncode = tcLib.secToTcMs(event.start + event.incodeSec, frameRate, dropFrame);
      event.endMsIncode = tcLib.secToTcMs(event.end + event.incodeSec, frameRate, dropFrame);
      event.startMsIncodeClock = tcLib.secToTcMs(incodeTime.applyPulldownDivider(event.start, frameRate, dropFrame) + event.incodeSec, frameRate, dropFrame);
      event.endMsIncodeClock = tcLib.secToTcMs(incodeTime.applyPulldownDivider(event.end, frameRate, dropFrame) + event.incodeSec, frameRate, dropFrame);
      event.startSmpteBase = tcLib.secToTc(event.start, frameRate, dropFrame);
      event.endSmpteBase = tcLib.secToTc(event.end, frameRate, dropFrame);
      event.startSmpteBaseClock = tcLib.secToTcClock(event.start, frameRate, dropFrame);
      event.endSmpteBaseClock = tcLib.secToTcClock(event.end, frameRate, dropFrame);
      let startTc = tcLib.createTc(event.startSmpteBase, frameRate, dropFrame);
      let endTc = tcLib.createTc(event.endSmpteBase, frameRate, dropFrame);
      event.startSmpteClock = tcLib.secToTcClock(event.start + event.incodeSec, frameRate, dropFrame);
      event.endSmpteClock = tcLib.secToTcClock(event.end + event.incodeSec, frameRate, dropFrame);
      let startTcClock = tcLib.createTc(event.startSmpteBaseClock, frameRate, dropFrame);
      let endTcClock = tcLib.createTc(event.endSmpteBaseClock, frameRate, dropFrame);
      startTc.add(incode);
      endTc.add(incode);
      startTcClock.add(incode);
      endTcClock.add(incode);
      event.startSmpte = startTc.toString();
      event.endSmpte = endTc.toString();
    } catch (err) {
      console.log(err);
      console.log("Error calculating timecode for Event: " + index, event.text);
      console.log(event);
    }
  });
  return eventGroup;
});